import * as React from 'react'

import { Box, RadioButton } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

interface Option {
  value: string
  label: string
  id: number
}

interface Props {
  options: Option[]
  field: Field
}

const LabeledFancyRadioGroup = (props: Props) => {
  const { field, options } = props

  return (
    <Box gap="s8">
      {options.map((option) => (
        <Box key={option.id}>
          <RadioButton
            label={option.label}
            checked={option.value === field.value}
            onChange={(event) => field.mapAndSet(event.target.value)}
            value={option.value}
          />
        </Box>
      ))}
    </Box>
  )
}

export default observer(LabeledFancyRadioGroup)
